import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { v2Route } from "~/v2/routes";
import { DbpjkitWorkerJobDetail } from "./components/DbpjkitWorkerJobDetail";
import { DbpjkitWorkerJobsContainer } from "./components/dbpjkitWorkerJobs.container";

function DbpjkitWorkerJobsLoading() {
  return <div className="mx-auto max-w-[var(--content-max)] p-8 text-[13px] text-fg-3">…</div>;
}

function DbpjkitWorkerJobDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.dbpjkitWorkerJobs.detail);
  const navigate = useNavigate();
  return <DbpjkitWorkerJobDetail id={id} onBack={() => navigate("..")} />;
}

export function DbpjkitWorkerJobsRoutes() {
  return (
    <Suspense fallback={<DbpjkitWorkerJobsLoading />}>
      <Routes>
        <Route index element={<DbpjkitWorkerJobsContainer />} />
        <Route path=":id" element={<DbpjkitWorkerJobDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
